import { gql } from "@apollo/client"

import { IGQLApiError } from "../api.types"
import apolloClient, { normalizeApolloError } from "../apolloClient"
import { AcceptCryptoLegalDocData, AcceptCryptoLegalDocResponse } from "./acceptCryptoLegalDoc.types"
import CommonApiError from "../errors/CommonApiError"
import parseHttpApiError from "../utils/parseHttpApiError"

const ACCEPT_CRYPTO_LEGAL_DOC = gql`
    mutation AcceptCryptoLegalDoc($input: AcceptCryptoLegalDocInput!) {
        acceptCryptoLegalDoc(input: $input) {
            requiresConsent
            hasAccepted
            currentTermsId
            currentTermsVersion
        }
    }
`

export const acceptCryptoLegalDoc = async (
    data: AcceptCryptoLegalDocData
): Promise<AcceptCryptoLegalDocResponse> => {
    const variables = {
        input: {
            companyId: data.companyId,
            cryptoProviderTermsId: data.cryptoProviderTermsId,
            source: data.source,
        },
    }

    try {
        const result = await apolloClient.mutate<
            AcceptCryptoLegalDocResponse["data"],
            typeof variables
        >({
            context: {
                headers: {
                    Authorization: `Bearer ${data.accessToken}`,
                },
            },
            fetchPolicy: "no-cache",
            mutation: ACCEPT_CRYPTO_LEGAL_DOC,
            variables,
        })

        return { data: result.data! }
    } catch (err: unknown) {
        const error = normalizeApolloError(err)
        if (error instanceof CommonApiError) {
            throw parseHttpApiError(error.body as IGQLApiError[])
        }
        throw error
    }
}
